module.exports = __webpack_public_path__ + "static/media/search.03064934.svg";